import React, { useState } from 'react';
import { FaCheck, FaClock, FaHashtag, FaInstagram, FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';

const getPlatformIcon = (platform) => {
    if (!platform) return null;
    switch (platform.toLowerCase()) {
        case 'instagram':
            return <FaInstagram className="text-pink-500" />;
        case 'facebook':
            return <FaFacebook className="text-blue-600" />;
        case 'linkedin':
            return <FaLinkedin className="text-blue-700" />;
        case 'twitter':
            return <FaTwitter className="text-blue-400" />;
        default:
            return null;
    }
};

const ProposalViewer = ({ proposal, onApprove }) => {
    const [selectedPosts, setSelectedPosts] = useState([]);

    const handleTogglePost = (index) => {
        setSelectedPosts(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div className="space-y-6">
            {/* Estrategia */}
            <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                    Estrategia Propuesta
                </h3>
                <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                    <p className="text-blue-800">{proposal.strategy}</p>
                </div>
                <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                    <div>
                        <span className="font-medium text-gray-700">Tema:</span>
                        <span className="ml-2 text-gray-600">{proposal.theme}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Audiencia:</span>
                        <span className="ml-2 text-gray-600">{proposal.targetAudience}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Tono:</span>
                        <span className="ml-2 text-gray-600">{proposal.tone}</span>
                    </div>
                </div>
            </div>

            {/* Posts Propuestos */}
            <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                    Posts Propuestos
                </h3>
                <div className="space-y-4">
                    {proposal.proposals.map((post, index) => (
                        <div
                            key={index}
                            className={`border rounded-lg p-4 transition-colors ${selectedPosts.includes(index)
                                    ? 'border-blue-500 bg-blue-50'
                                    : 'border-gray-200 hover:border-blue-300'
                                }`}
                        >
                            <div className="flex items-start">
                                <div className="flex-1">
                                    <div className="flex items-center space-x-2 mb-2">
                                        {getPlatformIcon(post.recommendedPlatform)}
                                        <h4 className="font-medium text-gray-900">{post.title}</h4>
                                    </div>
                                    <p className="text-gray-600 mb-3">{post.description}</p>

                                    <div className="flex flex-wrap gap-2 mb-3">
                                        {post.hashtags.map(tag => (
                                            <span
                                                key={tag}
                                                className="inline-flex items-center px-2 py-1 bg-gray-100 text-gray-600 text-sm rounded"
                                            >
                                                <FaHashtag className="mr-1 text-gray-400" size={12} />
                                                {tag}
                                            </span>
                                        ))}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
                                        <div className="flex items-center text-gray-600">
                                            <FaClock className="mr-2 text-gray-400" />
                                            {post.bestTimeToPost}
                                        </div>
                                        <div className="flex items-center text-gray-600">
                                            <span className="font-medium mr-2">CTA:</span>
                                            {post.cta}
                                        </div>
                                        <div className="flex items-center text-gray-600">
                                            <span className="font-medium mr-2">Plataforma:</span>
                                            {post.recommendedPlatform}
                                        </div>
                                    </div>
                                </div>

                                <div className="ml-4">
                                    <button
                                        onClick={() => handleTogglePost(index)}
                                        className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPosts.includes(index)
                                                ? 'bg-blue-500 border-blue-500 text-white'
                                                : 'border-gray-300 hover:border-blue-500'
                                            }`}
                                    >
                                        {selectedPosts.includes(index) && <FaCheck size={12} />}
                                    </button>
                                </div>
                            </div>

                            <div className="mt-3 pt-3 border-t border-gray-100">
                                <p className="text-sm text-gray-500">
                                    <span className="font-medium">Razonamiento:</span> {post.reasoning}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-6 flex justify-end">
                    <button
                        onClick={() => onApprove(selectedPosts)}
                        disabled={selectedPosts.length === 0}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Generar {selectedPosts.length} Posts Seleccionados
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProposalViewer; 